<template>
  <div class="stat_box card">
    <h3>
      <slot name="value" />
      <small>
        &nbsp;<slot name="diff" />
      </small><br>
      <small>
        <slot name="name" />
      </small>
    </h3>
    <slot name="chart" />
    <div class="limits">
      <small>
        <slot name="limitStart" />
      </small>
      <small>
        <slot name="limitEnd" />
      </small>
    </div>
    <div class="footer">
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
.stat_box {
  padding: 2rem;

  &.card {
    box-shadow: none;
  }

  h3 {
    font-size: 2rem;
    font-weight: 500;
    line-height: 1.6rem;

    small {
      font-size: 1rem;
      font-weight: 400;
    }
  }

  .limits {
    display: flex;
    justify-content: space-between;
  }

  :deep(.apexcharts-theme-statbox_tooltip) {
    display: flex;
    flex-direction: column-reverse;
    background: white;
    border: 1px solid #ccc;
    margin-top: -7px;

    .apexcharts-tooltip-text {
      width: 100%;
      text-align: center;

      .apexcharts-tooltip-text-y-value {
        margin-left: 0;
      }

      .apexcharts-tooltip-y-group {
        padding: 6px 0 0 0;
      }
    }

    .apexcharts-tooltip-title {
      padding-top: 0;
      margin-bottom: 0;
      color: #909096;
    }

    .apexcharts-tooltip-series-group.apexcharts-active,
    .apexcharts-tooltip-series-group:last-child {
      padding-bottom: 0;
    }
  }
}
</style>
